import React from "react";
import { Button } from "@mui/material";

export default function PinkLightExtraButton({
  startIcon,
  buttonTitle,
  onClick,
}) {
  return (
    <Button
      variant="contained"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      sx={{
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: 600,
        height: "30px",
        textTransform: "none",
        backgroundColor: "#FDF3FD",
        color: "#9D0385",
        px: 3,
        "&:hover": {
          backgroundColor: "#FDF3FD",
        },
      }}
    >
      {buttonTitle}
    </Button>
  );
}
